import * as angular from 'angular';
import usersRouter from './users.router';
import userService from './user.service';
import UserModel from './user.model.js';

/** @constant {angular.module} */
const usersModule = angular
  .module('ec.opsCenter.users', [])
  .config(usersRouter)
  .service('userService', userService)
  .factory('UserModel', UserModel).name;

export default usersModule;



// WEBPACK FOOTER //
// ./src/app/users/users.module.ts